import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { User as UserIcon, Paperclip as PaperclipIcon } from 'react-feather'
import { isEmpty } from 'lodash'
import { Box, Button, Chip, Paper, Typography } from '@material-ui/core'

import humps from 'humps'

import constants from 'constants/index'

import useStyles from './styles'
import helpers from 'helpers'
import theme from 'theme'

const ConsentLogBox = ({ consentFormAnswer }) => {
  const classes = useStyles()

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <Typography variant="h4" color="primary">
        Histórico de consentimentos
      </Typography>

      {consentFormAnswer?.answerAudits.map((answerAudit, index) => {
        const platform =
          humps.decamelizeKeys(consentFormAnswer?.platform) ?? 'privacy_portal'

        return (
          <Box key={index}>
            <Paper className={classes.userPaperContainer}>
              <Box
                display="flex"
                gridGap={theme.spacing(2)}
                alignItems="center"
              >
                <UserIcon className={classes.userIconBox} />
                <Box>
                  <Typography variant="h6" color="primary">
                    {answerAudit?.name}
                  </Typography>
                  {!!platform && (
                    <Typography variant="caption" color="secondary">
                      {constants.consent.PLATFORM_LABEL_CONSENT_HISTORY[
                        platform
                      ] || 'Referencia não encontrada'}
                    </Typography>
                  )}
                  <Typography color="textSecondary">
                    {answerAudit?.remoteAddress &&
                      `${answerAudit?.remoteAddress}|&nbsp;`}
                    {helpers.formatters.date(answerAudit?.createdAt)} às&nbsp;
                    {helpers.formatters.hours(answerAudit?.createdAt)}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Chip
                  className={
                    answerAudit?.status === constants.consent.AUTHORIZED_CONSENT
                      ? classes.statusLabelAuthorized
                      : classes.statusLabelRevoked
                  }
                  label={(
                    constants.consent.STATUS_LABEL_RECEIPT[
                      answerAudit?.status
                    ] || 'Não definido'
                  ).toUpperCase()}
                />
              </Box>
            </Paper>
            <Paper className={classes.contentPaperContainer}>
              <Typography color="textSecondary">
                {answerAudit.isExpired
                  ? constants.consent.CONSENT_HISTORY_CONTENT[
                      answerAudit.isExpired
                    ]
                  : constants.consent.CONSENT_HISTORY_CONTENT[platform]}
              </Typography>
              {!isEmpty(consentFormAnswer?.attachments) &&
                !answerAudit.isExpired && (
                  <Box>
                    <PerfectScrollbar
                      options={{
                        wheelPropagation: false,
                        useBothWheelAxes: true,
                      }}
                      className={classes.scrollbar}
                    >
                      {consentFormAnswer?.attachments?.map((attachment) => (
                        <Box key={attachment.url}>
                          <Button
                            startIcon={<PaperclipIcon size={18} />}
                            className={classes.buttonLink}
                            variant="text"
                            color="primary"
                            href={attachment.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {attachment.name}
                          </Button>
                        </Box>
                      ))}
                    </PerfectScrollbar>
                  </Box>
                )}
            </Paper>

            {consentFormAnswer?.observation && (
              <Box p={1} className={classes.lineObservation}>
                <Typography color="textSecondary">
                  Observação: {consentFormAnswer?.observation}
                </Typography>
              </Box>
            )}
          </Box>
        )
      })}
    </Box>
  )
}

export default ConsentLogBox
